import { createSlice } from '@reduxjs/toolkit';

export interface IEnums {
  orderType: string[];
  contractType: string[];
  employeeType: string[];
  genderType: string[];
  maritalType: string[];
  religionType: string[];
  roleType: string[];
  workModeType: string[];
  holidayType: string[];
  country: string[];
  projectType: string[];
  projectStatusType: string[];
  expensesType: string[];
  notificationType: string[];
  refundStatusType: string[];
}
const initialState: IEnums = {
  orderType: [],
  contractType: [],
  employeeType: [],
  genderType: [],
  maritalType: [],
  religionType: [],
  roleType: [],
  workModeType: [],
  holidayType: [],
  projectType: [],
  country: [],
  projectStatusType: [],
  expensesType: [],
  notificationType: [],
  refundStatusType: [],
};

const enumsSlice = createSlice({
  name: 'enums',
  initialState,
  reducers: {
    setEnums: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});

export default enumsSlice;
